let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ljTU4")).then(() => parcelRequire('6HEbk'));